const isIpadPro = () => {
    let ratio = window.devicePixelRatio || 1;
    let screen = {
        width : window.screen.width * ratio,
        height : window.screen.height * ratio
    };
    return (screen.width === 1488 && screen.height === 2266) ||(screen.width === 2048 && screen.height === 2732) || (screen.width === 2732 && screen.height === 2048) || (screen.width === 1536 && screen.height === 2048) || (screen.width === 2048 && screen.height === 1536) || (screen.width === 1668 && screen.height === 2388) || (screen.width === 2388 && screen.height === 1668) || (screen.width === 1620 && screen.height === 2160);
}
export default isIpadPro;

